/*
** TradeMinister
** Сreated on 19/11/2021
** by avavion.
*/

const DEBUG = false;
const PATHNAME = location.pathname;

// Enable scroll on page
const scrollOn = () => document.body.style.overflow = '';

// Disable scroll on page
const scrollOff = () => document.body.style.overflow = 'hidden';

// Country Switcher component

const countrySwitcher = () => {
  
  const removeCountryValue = () => {
    localStorage.removeItem('country');
  }

  const EXCEPTIONS = {
    UA: function() {
      removeCountryValue();
      location.href = "https://beggani.ua/?redirect";
    }
  };

  const $ = document.getElementById('countrySwitcher');

  if (parent) {
    const select = $.querySelector('select');
    const BUTTONS = document.querySelectorAll('.js-country-switcher');
    const CLOSE_TRIGGERS = $.querySelectorAll('.js-close');
    const SAVE_BUTTON = $.querySelector('.btn--save');

    const toggleSidebar = () => {
      const body = document.body;
      const overlay = document.querySelector('.box_contentmenu_background');
      const menu = document.querySelector('.box_contentmenu');


      body.classList.remove('activemenu_mobile');
      overlay.classList.remove('active');
      menu.classList.remove('active');
    }
    
    const isNewUser = () => {
      if (localStorage.getItem('country') === null) {
      	return true;
      }
      
      return false;
    }

    const show = () => {
      $.classList.add('active');
      $.nextElementSibling.classList.add('active');
      toggleSidebar();
      scrollOff();
    }

    const hide = () => {
      $.classList.remove('active');
      $.nextElementSibling.classList.remove('active');
      toggleSidebar();
      scrollOn();
    }

    const getCountryValue = () => {
      return localStorage.getItem('country');
    }

    const setCountryValue = (value) => {
      localStorage.setItem('country', value.toUpperCase());
      return value.toUpperCase()
    }

    const setSelectedAttr = (el) => {
      el.setAttribute('selected', 'selected');
    }

    const getCountries = () => {
      const dataset = document.getElementById('countryList');
      return JSON.parse(dataset.textContent);
    }
    
    const isRedirect = () => {
      if (location.search.match('redirect') === null) {
      	return false;
      }
      
      return true;
    }
    
    if (isRedirect()) {
      const code = location.search.split('=')[1];
      
      setCountryValue(code);
      
      location.href = location.origin;
    } else {
      isNewUser() && show();    
    }
    

    const code = getCountryValue() === null ? setCountryValue("GB") : getCountryValue();

    const createElement = (data) => {
      const option = document.createElement('option');

      if (code === data.value) setSelectedAttr(option);

      option.setAttribute('value', data.value);

      option.textContent =  data.display;

      return option;
    }

    const render = () => {
      for (const data of countries) {
        select.appendChild(createElement(data));
      }
    }

    const handleSelect = (e) => {
      const options = e.currentTarget.options;
      const selected = options[e.currentTarget.selectedIndex];

      const selectedValue = selected.value;

      if (DEBUG) {
        console.log("selectedValue", selectedValue);
      }

      (EXCEPTIONS[selectedValue] ?? setCountryValue.bind(this, selectedValue))();

      for (const _ of options) {
        _.removeAttribute('selected');
      }

      setSelectedAttr(selected);
    }

    const handleClick = () => {
      const options = select.options;
      const selected = options[select.selectedIndex];

      const selectedValue = selected.value;

      if (DEBUG) {
        console.log("selectedValue", selectedValue);
      }

      (EXCEPTIONS[selectedValue] ?? setCountryValue.bind(this, selectedValue))();

      for (const _ of options) {
        _.removeAttribute('selected');
      }

      setSelectedAttr(selected);
      hide();
    }

    const countries = getCountries().sort((a, b) => a.display.localeCompare(b.display))

    // If user click overlay, close popup window
    $.nextElementSibling.addEventListener('click', (event) => event.target === $.nextElementSibling && hide());

    for (const button of BUTTONS) button.addEventListener('click', show);
    for (const button of CLOSE_TRIGGERS) button.addEventListener('click', hide);
    SAVE_BUTTON.addEventListener('click', handleClick);

    render();

    if (getCountryValue() === null) {
      show();
    }
  }
}

// Clipboard copy function

const clipboard = (data) => {
  if (navigator.clipboard) {
    
    navigator.clipboard.writeText(data)
      .then(() => {
        console.log("Скопированно: ", data);                            
      })
      .catch((error) => {
        console.error("Ошибка копирования: ", error);
      });
  }
}

const socialShare = () => {
  const $ = document.getElementById('copyLink');
  
  if (!$) {
  	return false;
  }
  
  const URL = $.getAttribute('data-url');
  
  $.addEventListener('click', () => clipboard(URL));
}

// Init all functions
const init = () => {
  countrySwitcher();
  socialShare();
}

document.addEventListener("DOMContentLoaded", init);